export enum MeasurementCategory {
  Mass = 0,
  Distance = 1,
  Volume = 2,
  Other = 10
}